import Footer from "./footer";
import Project from "./project";


function ProjectPage(){
    return(
        <> 
        <Project/>
        <Footer/>
        </>
    );
}
export default ProjectPage;